import styled from 'styled-components';
import { InnerScrollMixin } from '@treelab/panda';

interface Wrapper {
  isPortrait: boolean;
  isExpand: boolean;
  height: number | null;
}

export const ScrollContainer = styled.div<{ isExpand: boolean }>`
  ${InnerScrollMixin}
  flex: 1;
  overflow-y: overlay;

  &::-webkit-scrollbar {
    ${({ isExpand }) => (!isExpand ? `display: none;` : null)}
    background-color: rgba(255, 255, 255, 0.8);
  }

  ${({ isExpand }) =>
    isExpand
      ? `
    overflow: auto;
    padding: 20px;
  `
      : null}
`;

export const Wrapper = styled.div<Wrapper>`
  margin: 0 auto;
  box-shadow: ${(props) => (!props.isExpand ? 'none' : '0 8px 24px 0 rgba(0, 0, 0, 0.2)')};
  width: ${(props) => (props.isPortrait ? '792px' : '1122px')};
  height: ${(props) => (props.height ? props.height : props.isPortrait ? 1122 : 792)}px;
  position: relative;

  transform-origin: top left;
`;

export const Wrapperer = styled.div<{ isPortrait: boolean; height: number | null; scale: number }>`
  height: ${(props) =>
    props.height
      ? props.height * props.scale
      : props.isPortrait
      ? 1122 * props.scale
      : 792 * props.scale}px;
  position: relative;
`;
